export class Organisme {
    nom: string;
    numero: number;

    constructor(
        nom: string,
        numero: number,
    ) {
        this.nom = nom;
        this.numero = numero;
    }

    static factory(organismeAPI: OrganismeAPI): Organisme {
        return new Organisme(
            organismeAPI.Nom,
            organismeAPI.CentrePayeur,
        );
    }
}

export type OrganismeAPI = {
    Nom: string;
    CentrePayeur: number;
}